<template>
  <div>
    <h2>
      <span class="form-group">
        Animal Health
        <comments field-name="heading_animal_health" :isReadOnly="isReadOnly"></comments>
      </span>
    </h2>
		<div class="alert alert-success text-center">
			Most of this step is optional except for the flowcharts fields at the bottom of the page
		</div>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <h3>{{ farm.farm_label }}</h3>

        <fieldset>
          <legend>
            <span class="form-group">
              Other Health Issues
              <comments :field-name="`farm_${farm.id}-heading_other_health_issues`" :isReadOnly="isReadOnly"></comments>
            </span>
          </legend>

          <div class="disease">
            <span class="form-group">
              <label>Down Cow</label>
              <comments :field-name="`farm_${farm.id}-other_issues_downcow`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Bloat</label>
              <comments :field-name="`farm_${farm.id}-other_issues_bloat`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Pink Eye</label>
              <comments :field-name="`farm_${farm.id}-other_issues_pinkeye`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Acidosis</label>
              <comments :field-name="`farm_${farm.id}-other_issues_acidosis`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Scouring</label>
              <comments :field-name="`farm_${farm.id}-other_issues_scouring`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Abortions</label>
              <comments :field-name="`farm_${farm.id}-other_issues_abortions`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Sudden Death</label>
              <comments :field-name="`farm_${farm.id}-other_issues_suddendeath`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Salmonella</label>
              <comments :field-name="`farm_${farm.id}-other_issues_salmonella`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Polio</label>
              <comments :field-name="`farm_${farm.id}-other_issues_polio`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>

          <div class="disease">
            <span class="form-group">
              <label>Calvings</label>
              <comments :field-name="`farm_${farm.id}-other_issues_calvings`" :isReadOnly="isReadOnly"></comments>
            </span>
          </div>
        </fieldset>

				<div class="mandatory-fields">
					<fieldset class="flowchart">
						<legend>
							<span class="form-group">
								Flowcharts
								<i
									class="glyphicon glyphicon-envelope"
									v-tooltip="'Email might be generated'"
									title="Email might be generated"
								>
								</i>
								<comments :field-name="`farm_${farm.id}-flowcharts`" :isReadOnly="isReadOnly"></comments>
							</span>
						</legend>

						<div class="flowchart-fields text-left">
							<check-box
								label="Mastitis"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_mastitis`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Down Cow"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_down_cows`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="RFMs"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_rfms`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Calvings"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_calving`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Post-calving"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_post_calving`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Calf Rearing"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_calf_rearing`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Animal Health Plan"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_animal_health_plan`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Young Stock Health Plan"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_young_stock_health_plan`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Rumination sick cow"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_rumination`"
								:show-input-box="false"
							>
							</check-box>

							<check-box
								label="Dairy fluid therapy"
								:disabled="isReadOnly"
								:field-name="`farm_${farm.id}-flowchart_fluid_therapy`"
								:show-input-box="false"
							>
							</check-box>
						</div>
					</fieldset>
				</div>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'AnimalHealth',
  mixins: [baseComponent],
  methods: {
    toggleNotifications: function () {
      let fields = [
        'flowchart_mastitis',
        'flowchart_down_cows',
        'flowchart_rfms',
        'flowchart_calving',
        'flowchart_post_calving',
        'flowchart_calf_rearing',
        'flowchart_animal_health_plan',
        'flowchart_young_stock_health_plan',
      ]

      let fieldNames = this.FARMS.map((farm) => fields.map((field) => `farm_${farm.id}-${field}`)).flat()

      this.setEmailNotification({
        slug: 'flowcharts-needed',
        value: fieldNames.some((fieldName) => Boolean(this.getFieldValue(fieldName, this.$options.name))),
      })
    },
  },
}
</script>

<style>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}

div .disease {
  margin-bottom: 1em;
}

.mandatory-fields {
	border: 2px solid rgba(255, 0, 0, .7);
	border-radius: 5px;
}
</style>
